import { v4 as uuidV4 } from 'uuid'

export const generateUuidList = (length: number) => {
  const array = new Array(length).fill(null)

  return array.map(() => uuidV4())
}

export const generateListUuidLists = (
  listLength: number,
  entriesPerList: number
) => {
  const array = new Array(listLength).fill(null)

  return array.map(() => generateUuidList(entriesPerList))
}
